import { DataObject } from '@/utils/DataObject';
import { Absence } from './Absence';

export class AbsenceTransformer {
  public toClass(data: DataObject = {}): Absence {
    console.log("AbsenceTransformer", data);
    return new Absence({
      absentSince: data ? data.absent_since : null,
      absentUntil: data ? data.absent_until : null,
      id: data ? data.id : null
    })
  }
}
